import Analytics from './Analytics.component';

export default Analytics;
